import { render } from "./LegalDocumentContent.vue?vue&type=template&id=79851a56&scoped=true"
const script = {}

import "./LegalDocumentContent.vue?vue&type=style&index=0&id=79851a56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79851a56"]])

export default __exports__